// extracted by mini-css-extract-plugin
export default {"wrapper":"ChangeOrderOfAlbumsBtn_wrapper__wAlTG","change-order":"ChangeOrderOfAlbumsBtn_change-order__2lfcJ"};